import {http} from 'lib/httpAxios'

export default {
  retrieveDocumentList (parameters) {
    return http.post(`/documents/search/${parameters.page.Page}/10`, parameters.params)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveDocument (parameters) {
    return http.get(`/documents/${parameters.documentId}/${parameters.documentType}`)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveDocumentTypes (parameters) {
    return http.get(`/documentstypes/${parameters.params.AccountCode}`)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  },
  retrieveDocumentImages (parameters, headerToken) {
    return http.get(`/documents/${parameters.AccountCode}/${parameters.documentId}/${parameters.documentType}/${parameters.eventCode}/images`, {headers: {'Authorization': `Basic ${parameters.headerToken}`}})
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error))
  }
}



// WEBPACK FOOTER //
// ./src/vuex/api/services/monitoring.js